import { useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import { FieldError } from "../../components/common/States";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Field } from "./Register";

export default function Contact() {
  const { user } = useAuth();
  const [f, setF] = useState({ name: user?.name || "", email: user?.email || "", subject: "", message: "" });
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (f.name.trim().length < 2) errs.name = "Nom requis";
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email)) errs.email = "Email invalide";
    if (f.subject.trim().length < 3) errs.subject = "Objet requis (3 caractères min.)";
    if (f.message.trim().length < 10) errs.message = "Message trop court (10 caractères min.)";
    setErrors(errs);
    if (Object.keys(errs).length) return;
    setSending(true);
    try { await api.post("/public/contact", f); setDone(true); }
    catch (err) { toast.error(formatApiError(err)); } finally { setSending(false); }
  };

  return (
    <div className="mx-auto max-w-2xl px-4 py-14 sm:px-6">
      <p className="eyebrow">Contact</p>
      <h1 className="mt-3 font-display text-3xl font-bold tracking-tight sm:text-4xl">Écrire à l'équipe VOXA AFRIKA</h1>
      <p className="mt-2 text-sm text-slate-500">Question sur la plateforme, demande d'information pour votre organisation ou signalement. Pour un retour sur une organisation, utilisez plutôt sa fiche dans l'annuaire.</p>
      {done ? (
        <div className="card-surface mt-8 p-8 text-center" data-testid="contact-success">
          <CheckCircle2 className="mx-auto h-10 w-10 text-emerald-600" />
          <p className="mt-4 font-display text-lg font-semibold">Message envoyé</p>
          <p className="mt-1 text-sm text-slate-500">Notre équipe vous répondra à l'adresse indiquée.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="card-surface mt-8 space-y-4 p-6" noValidate>
          <div className="grid gap-4 sm:grid-cols-2">
            <Field id="contact-name" label="Nom" value={f.name} onChange={set("name")} error={errors.name} />
            <Field id="contact-email" label="Email" type="email" value={f.email} onChange={set("email")} error={errors.email} />
          </div>
          <Field id="contact-subject" label="Objet" value={f.subject} onChange={set("subject")} error={errors.subject} maxLength={150} />
          <div><Label htmlFor="contact-message">Message</Label><Textarea id="contact-message" rows={6} maxLength={3000} className="mt-1.5" value={f.message} onChange={set("message")} data-testid="contact-message-input" /><FieldError>{errors.message}</FieldError></div>
          <Button type="submit" disabled={sending} className="h-11 w-full rounded-full" data-testid="contact-submit-button">{sending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Envoyer</Button>
        </form>
      )}
    </div>
  );
}
